// List of official 2-character Welsh digraphs
export const WELSH_DIGRAPHS = ['CH', 'DD', 'FF', 'NG', 'LL', 'PH', 'RH', 'TH'];

// Welsh Vowels
export const WELSH_VOWELS = ['A', 'E', 'I', 'O', 'U', 'W', 'Y', 'Â', 'Ê', 'Î', 'Ô', 'Û', 'Ŵ', 'Ŷ'];

/**
 * Parses a string into an array of Welsh tile tokens (recognizing digraphs).
 * e.g., "CHWARAE" -> ["CH", "W", "A", "R", "A", "E"]
 */
export const tokenizeWelshWord = (word) => {
    if (!word) return [];
    const upper = word.toUpperCase();
    const tokens = [];
    let i = 0;

    while (i < upper.length) {
        if (i < upper.length - 1) {
            const pair = upper.substring(i, i + 2);
            if (WELSH_DIGRAPHS.includes(pair)) {
                tokens.push(pair);
                i += 2;
                continue;
            }
        }
        tokens.push(upper[i]);
        i++;
    }
    return tokens;
};

/**
 * Checks if a tile/character is a Welsh vowel.
 */
export const isWelshVowel = (tile) => {
    if (!tile) return false;
    return WELSH_VOWELS.includes(tile.toUpperCase());
};

/**
 * Counts vowels in an array of tile strings.
 */
export const countVowelsInTiles = (tilesArray) => {
    let count = 0;
    tilesArray.forEach(tile => {
        if (isWelshVowel(tile)) {
            count++;
        }
    });
    return count;
};